import { Textbox } from "components/Textbox/Textbox";
import { Button } from "components/Button/Button";
import { useEffect, useState } from "react";
import { Response } from "types/types";
import { Loading } from "components/Loading/loading";
import {
  getRelationsCustomerById,
  postRelationsCustomer

} from "./api";
import { CheckableButton } from "components/CheckableButton/CheckableButton";
import { EnumerationTypeSelect } from "components/EnumerationTypeSelect/EnumerationTypeSelect";
interface Prop {
  resetForm?: boolean;
  onHide: any;
  selectedObj?: any;
  mode: string;
  reload: () => void;
}

export const CustomersRelationForm = ({
  reload,
  onHide,
  mode,
  selectedObj,
}) => {
  const [resetForm, setResetForm] = useState(false);
  const [response, setResponse] = useState<Response | any>();
  const [userChanges, setUserChanges] = useState({});
  const [loading, setLoading] = useState<any>();

  const handleBeforeUnload = (event) => {
    event.preventDefault();
    event.returnValue = "";
  };

  useEffect(() => {
    if (Object.values(userChanges).filter((item) => item != null).length > 0) {
      sessionStorage.setItem("changingforms", "true");
      window.addEventListener("beforeunload", handleBeforeUnload);
      return () => {
        window.removeEventListener("beforeunload", handleBeforeUnload);
      };
    } else {
      sessionStorage.setItem("changingforms", "false");
      window.removeEventListener("beforeunload", handleBeforeUnload);
    }
  }, [userChanges]);

  async function getRelationsCustomerByIdAsync() {
    setLoading(false);
    try {
      const data = await getRelationsCustomerById(selectedObj?.Id);
       setResponse(data.Data);
     } catch (error) {}
    setLoading(true);
  }

  const submit = (e) => {
    e.preventDefault();
    if (mode==='create') {
      postRelationsCustomer({
        IsDefault: e.target.CustomerRelationCheckbox.checked,
        Title: e.target.CustomerRelationTitle.value,
        TitleEN: e.target.CustomerRelationTitleEN.value,
        SystemKey: e.target.CustomerRelationSystemKey.value,
      },'post').then(() => {
        sessionStorage.setItem("changingforms", "false");
        setUserChanges({});
      
      });
    } else {
      postRelationsCustomer({
        IsDefault: e.target.CustomerRelationCheckbox.checked,
        Title: e.target.CustomerRelationTitle.value,
        TitleEN: e.target.CustomerRelationTitleEN.value,
        SystemKey: e.target.CustomerRelationSystemKey.value,
        ActivityStatus: +e.target.CustomerRelationSelect.value,
        Id: selectedObj?.Id,
      },'put').then(() => {
        sessionStorage.setItem("changingforms", "false");
        setResponse(null);
        setUserChanges({});
 
      });
    }
  reload()
  onHide()
  };

  useEffect(() => {
    if (selectedObj && mode != "create") {
      getRelationsCustomerByIdAsync();
    } else {
      setResponse(null);
      setLoading(true);
    }
  }, [selectedObj, mode]);

  useEffect(() => {
    if (resetForm) {
      setUserChanges({});
      setResponse(null);
    }
  }, [resetForm]);

  return (
    <>
      <div className="card mb-4">
        {loading ? (
          <form className="TypeSettingForm row card-body " onSubmit={submit}>
            <div className="col-md-4 col-sm-12">
              <Textbox
                Change={(e) => {
                  setUserChanges({ ...userChanges, ...e });
                }}
                required={true}
                textboxName={"CustomerRelationTitle"}
                textboxType="text"
                resetForm={resetForm}
                labelText={"Title"}
                mode={mode}
                defaultValue={response?.Title}
              />
            </div>
            <div className="col-md-4 col-sm-12">
              <Textbox
                Change={(e) => {
                  setUserChanges({ ...userChanges, ...e });
                }}
                required={true}
                textboxName={"CustomerRelationTitleEN"}
                textboxType="text"
                resetForm={resetForm}
                labelText={"TitleEN"}
                mode={mode}
                defaultValue={response?.TitleEN}
              />
            </div>
            <div className="col-md-4 col-sm-12">
              <Textbox
                Change={(e) => {
                  setUserChanges({ ...userChanges, ...e });
                }}
                required={true}
                textboxName={"CustomerRelationSystemKey"}
                textboxType="systemKey"
                resetForm={resetForm}
                labelText={"systemKey"}
                mode={mode}
                defaultValue={response?.SystemKey}
              />
            </div>
            {mode != "create" && (
              <div className="col-lg-4 mt-1">
                <EnumerationTypeSelect
                  Change={(e) => {
                    setUserChanges({ ...userChanges, ...e });
                  }}
                  name="CustomerRelationSelect"
                  mode={mode}
                  label="Status"
                  enumTypeSelect="ActivityStatus"
                  value={response?.ActivityStatus}
                />
              </div>
            )}
            <div className=" mt-4 mb-4">
              <CheckableButton
                Change={(e) => {
                  setUserChanges({ ...userChanges, ...e });
                }}
                defaultChecked={response?.IsDefault}
                defaultValue={response?.IsDefault}
                labelText={"IsDefault"}
                inputName={"CustomerRelationCheckbox"}
                type="checkbox"
                mode={mode}
              />
            </div>
            {mode != "view" ? (
              <div className="col-lg-12 mt-1 btns_form">
                <Button value="Save" btnType="submit" />
                <Button
                  btnType="cancel"
                  value="Cancel"
                  onClick={() => {
                    onHide();
                  }}
                />
              </div>
            ) : (
              <div className="col-lg-12 mt-1 btns_form">
                <Button
                  btnType="primary"
                  value="close"
                  onClick={() => {
                    onHide();
                  }}
                />
              </div>
            )}
          </form>
        ) : (
          <Loading />
        )}
      </div>
    </>
  );
};
